// @ts-nocheck
import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { navPermissionCheck } from '../../auth/authUtils';

function TopMenuItem({
  currentUser,
  allowedPermissions,
  allowedUserTypes,
  isPowerUser,
  activeRegex,
  activeif,
  url,
  title,
  children,
}) {
  let hasPermission = navPermissionCheck(
    currentUser,
    allowedPermissions,
    allowedUserTypes,
    isPowerUser
  );

  const location = useLocation();
  const isActive =
    activeRegex !== undefined
      ? location.pathname.match(RegExp(activeRegex))
        ? 'is-current'
        : ''
      : location.pathname.startsWith(activeif !== undefined ? activeif : url)
        ? 'is-current'
        : '';
  return hasPermission ? (
    <li className={`float-left ${isActive}`}>
      <NavLink tag={Link} className={`no-pad-tb bold ${isActive}`} to={url}>
        {title}
      </NavLink>
      {children}
    </li>
  ) : null;
}

export default TopMenuItem;
